<template>
  <div>
    <NavBar />
    <Carousel />
    <!-- <Section /> -->
    <Footer />
  </div>
</template>
<script>
import NavBar from "@/components/NavBar/NavBar.vue";
import Carousel from "@/components/Carousel/Carousel.vue";
// import Section from "@/components/Section/Section.vue";
import Footer from "@/components/Footer/Footer.vue";
export default {
  name: "HomeIndex",
  components: {
    NavBar,
    Carousel,
    // Section,
    Footer,
  },
};
</script>
<style lang="scss">
</style>